export class ValidationUtil {
    
    public static readonly  INVALID_PASSWORD_ERROR: String = "Password must contains at least 8 characters and at most 16 characters, at least one digit, one upper case alphabet, one lower case alphabet, one special character which includes !@#$%&*^ and doesn’t contain any white space.";
    public static isValidPassword(password: string):boolean {
        var result = password.match("^(?=.*[0-9])" + "(?=.*[a-z])(?=.*[A-Z])" + "(?=.*[!*@#$%^&+=])" + "(?=\\S+$).{8,16}$");
       
        return result ? true : false;
    }
}